var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { css } from "@emotion/css";
import MainNavigation from "./MainNavigation";
var NavigationWrapper = function () {
    return (_jsx("div", __assign({ className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        position: fixed;\n        top: 0px;\n        left: 0px;\n        width: 100%;\n        background-color: rgb(255, 255, 255);\n        box-shadow: rgb(0 0 0 / 16%) 0px 5px 11px 0px;\n        z-index: 1;\n        transition: all 0.2s ease-in 0s;\n      "], ["\n        position: fixed;\n        top: 0px;\n        left: 0px;\n        width: 100%;\n        background-color: rgb(255, 255, 255);\n        box-shadow: rgb(0 0 0 / 16%) 0px 5px 11px 0px;\n        z-index: 1;\n        transition: all 0.2s ease-in 0s;\n      "]))) }, { children: _jsx(MainNavigation, {}) })));
};
export default NavigationWrapper;
var templateObject_1;
